var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to}},[_vm._t("default"),_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-chevron-right")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }